import React, { useState } from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import Textfield from '@atlaskit/textfield';
export const EditNumber = ({
  id,
  value,
  isInvalid,
  isRequired,
  onChange,
  label,
  jiraField
}) => {
  // Since Jira adds .0 to the end of the number, we will omit it. 
  // But we will still allow the user to fill out .0 themselves
  const [userHasEdited, setUserHasEdited] = useState(false);
  return /*#__PURE__*/React.createElement(Textfield, {
    id: id,
    value: jiraField && !userHasEdited && fg('proforma_remove_floating_zero') ? value === null || value === void 0 ? void 0 : value.replace(/\.0$/, '') : value,
    isInvalid: isInvalid,
    isRequired: isRequired,
    onChange: onChange,
    onInput: fg('proforma_remove_floating_zero') ? () => setUserHasEdited(true) : undefined,
    width: "small",
    label: label,
    "aria-label": label,
    title: label,
    placeholder: ""
  });
};